import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Landing = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  if (!isLoading && isAuthenticated) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen w-full">
      <div id="landing-layout" className="min-h-screen w-full grid grid-cols-1 md:grid-cols-2 md:min-w-0">
        {/* Left: image block - hidden on mobile, visible on tablet/desktop */}
        <div className="landing-left flex max-md:hidden relative min-h-screen h-screen min-w-0 bg-slate-950 p-0 overflow-hidden order-2 md:order-1">
          <img
            src="/landing-side-img.jpg"
            alt="YuvanAPI Landing"
            className="w-full h-full object-cover object-center opacity-80"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4">
            <div className="text-center rounded-2xl bg-black/40 backdrop-blur-sm px-6 py-5 shadow-xl border border-white/10">
              <h1 className="text-white font-bold text-3xl sm:text-4xl md:text-5xl uppercase tracking-wider mb-3 m-0 drop-shadow">Download APP</h1>
              <a
                href={process.env.REACT_APP_ANDROID_APP_URL || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 py-3 px-5 text-sm font-semibold uppercase tracking-wide text-white rounded-xl bg-violet-600 hover:bg-violet-500 shadow-lg transition-all whitespace-nowrap"
              >
                <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download YuvanAPI Android App
              </a>
            </div>
          </div>
        </div>

        {/* Right: panel block - full width on mobile, 50% on desktop */}
        <div className="landing-right relative min-h-screen flex flex-col min-w-0 bg-slate-900 px-4 py-8 sm:px-6 sm:py-10 md:px-12 md:py-16 order-1 md:order-2">
        <div
          className="absolute inset-0 z-0 pointer-events-none opacity-50"
          style={{
            backgroundImage: `linear-gradient(rgba(139, 92, 246, 0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(139, 92, 246, 0.04) 1px, transparent 1px)`,
            backgroundSize: '40px 40px',
          }}
          aria-hidden
        />
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center w-full max-w-[400px] mx-auto text-center md:text-left px-1 min-h-0">
          <div className="flex justify-center md:justify-start mb-2">
            <img
              id="landing-logo"
              src={`${process.env.PUBLIC_URL || ''}/logo.png`}
              alt="YuvanAPI Logo"
              className="w-52 h-auto sm:w-60 md:w-72 object-contain drop-shadow-lg shrink-0"
            />
          </div>
          <p className="text-xs sm:text-[0.8125rem] font-semibold tracking-[0.14em] uppercase text-violet-200 mb-3">
            Engineering Future Solutions
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-white mb-3 leading-tight">
            YuvanAPI System v2.0
          </h1>
          <p className="text-base text-white/75 leading-relaxed mb-8">
            Choose the portal you want to access.
          </p>

          <div className="space-y-3 flex flex-col w-full">
            <Link
              to="/login"
              className="w-full py-3.5 px-6 text-sm sm:text-base font-semibold tracking-wide uppercase text-white rounded-lg bg-violet-600 hover:bg-violet-500 border border-violet-500/60 shadow-sm transition-colors text-center inline-block box-border"
            >
              Retail Login
            </Link>
          </div>

          {/* Mobile download CTA (shown below buttons) */}
          <div id="landing-mobile-download" className="mt-10 flex flex-col items-center space-y-3 md:hidden">
            <h2 className="text-white font-bold text-2xl uppercase tracking-wider mt-4 mb-1">
              Download APP
            </h2>
            <a
              href={process.env.REACT_APP_ANDROID_APP_URL || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 py-3 px-5 text-sm font-semibold uppercase tracking-wide text-white rounded-xl bg-violet-600 hover:bg-violet-500 shadow-lg transition-all whitespace-nowrap"
            >
              <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Download YuvanAPI Android App
            </a>
          </div>
        </div>

        <div className="relative z-10 w-full max-w-[400px] mx-auto mt-auto pt-6 pb-8 sm:pb-6 shrink-0 text-center">
          <div className="flex flex-wrap items-end justify-center gap-3 mb-3">
            <img
              src="/specs.png"
              alt="SSL Secure Connection"
              className="h-30 w-auto object-contain object-bottom"
            />
           
          </div>
          <p className="text-sm text-slate-400 mt-2 mb-0">
            Built by Algobasket
          </p>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
